import { BULK_FETCH_COMMENTS_REQUEST, FETCH_DEEP_LINK_REQUEST, FETCH_COMMENTS_REQUEST, } from '../comments/paging/comments-paging-actions';
import { updateFetchMode } from '../meta-state/meta-state-actions';
export const fetchModeMiddleware = (store) => (next) => (action) => {
    const fetchMode = store.getState().metaState.fetchMode;
    const nextFetchMode = fetchMode === 'comments_only' ? 'comments_and_interactions' : 'comments_and_interactions';
    if (fetchMode !== nextFetchMode) {
        switch (action.type) {
            case BULK_FETCH_COMMENTS_REQUEST:
            case FETCH_DEEP_LINK_REQUEST:
            case FETCH_COMMENTS_REQUEST: {
                next(updateFetchMode(nextFetchMode));
                break;
            }
        }
    }
    return next(action);
};
//# sourceMappingURL=fetch-mode-middleware.js.map